// import { getEnvs } from '@/shared/utils';
// const { VITE_BUCKET_BASE } = getEnvs();
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  emptyCellOneLevel,
  hasAllPermissions,
  useCheckPermissions,
  useTableServerSideFiltering,
} from "@/shared";
import { useDeleteRadius, useFetchRadius } from "@/shared/actions/erp";
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTableFilter } from "@/shared/hooks/useTableFilter";
import { OLT } from "@/shared/interfaces";
import { useUiConfirmModalStore } from "@/store/ui";
import { SAVE_RADIUS_PERMISSIONS } from "../../shared/constants";
import { Radius } from '@/shared/interfaces/erp/configuracion-red/radius';

export type RadiusPageProps = {};

const RadiusPage: React.FC<RadiusPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_radius);

  const returnUrlRadiusPage = ROUTER_PATHS.configuracionRED.radiusNav;

  const navigate = useNavigate();

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  const deleteRadius = useDeleteRadius();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  const { filterObject, columnFilters, setColumnFilters } =
      useTableServerSideFiltering();

  ///* fetch data
  const {
    data: RadiusPagingRes,
    isLoading,
    isRefetching,
  } = useFetchRadius({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      codigo: searchTerm,
      ...filterObject,
    },
  });

  ///* handlers

  const onEdit = (radius: Radius) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar Radius",
      subtitle: "¿Está seguro que desea editar este Radius?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrlRadiusPage}/editar/${radius.id_radius}`);
      },
    });
  };

  const onDelete = (radius: Radius) => {
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar Radius",
      subtitle: "¿Está seguro que desea eliminar este Radius?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteRadius.mutate(radius.id_radius!);
      },
    });
  };

  const columns = useMemo<MRT_ColumnDef<OLT>[]>(
    () => [
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "nombre"),
      },
      {
        accessorKey: "hostname",
        header: "Hostname",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "hostname"),
      },
      {
        accessorKey: "codigo",
        header: "código",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "codigo"),
      },
      {
        accessorKey: "direccion",
        header: "dirección",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "direccion"),
      },
      {
        accessorKey: "coordenadas",
        header: "Coordenadas",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "coordenadas"),
      },
      // {
      //   accessorKey: "descripcion",
      //   header: "Descripción",
      //   size: 180,
      //   Cell: ({ row }) => emptyCellOneLevel(row, "descripcion"),
      // },
    ],
    []
  );

  //CUSTOM HOOKS

  // const { fileInputRef: importRadius, handleImportarOLT } = useUploadFile();

  return (
    <SingleTableBoxScene
      title="Radius"
      urlRedirect={`${returnUrlRadiusPage}/crear`}
      enableRedirect={hasAllPermissions([
        ...SAVE_RADIUS_PERMISSIONS,
        PermissionsEnum.api_add_radius,
      ])}
      //excel
      // enableUploadFile={true}
      // enableDownloadFile={true}
      // fileInputRef={importRadius}
      // importationName={"Subir Radius"}
      // handleFileUpload={handleImportarOLT}
      // importationsQuantity={1}
      // urlDownloadPlantilla={
      //   "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT
      // }
      // urlDownloadNameExcel={"plantilla_olt"}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="por código de Radius"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<Radius>
        columns={columns}
        data={RadiusPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={RadiusPagingRes?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // actions ========
        enableColumnActions={hasAllPermissions([
          ...SAVE_RADIUS_PERMISSIONS,
          PermissionsEnum.api_change_radius,
        ])}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={hasAllPermissions([
          ...SAVE_RADIUS_PERMISSIONS,
          PermissionsEnum.api_change_radius,
        ])}
        onEdit={onEdit}
        canDelete={false}
        onDelete={onDelete}
      />
    </SingleTableBoxScene>
  );
};

export default RadiusPage;
